<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Consultar tarificador
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- RANGO DE FECHA -->
              <v-col cols="12">
                <v-menu
                  ref="dateRangeMenu"
                  v-model="dateRangeMenu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dates"
                      required
                      filled
                      rounded
                      class="rounded-small"
                      label="Rango de fecha"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-us"
                    v-model="dates"
                    :max="new Date().toISOString().substr(0, 10)"
                    range
                    scrollable
                    no-title
                  >
                    <v-spacer></v-spacer>
                    <v-hover v-slot:default="{ hover }">
                      <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="dateRangeMenu = false"
                        >Cancelar</v-btn
                      >
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                      <v-btn
                        rounded
                        :loading="isLoading"
                        :disabled="isLoading"
                        color="success"
                        :class="hover ? 'shadow-2' : 'shadow-4'"
                        class="px-8"
                        @click="$refs.dateRangeMenu.save(dates), !module.includes('agents') && getExtensionDate()"
                        >ok</v-btn
                      >
                    </v-hover>
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!-- Tipo -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="tipo" rules="" v-slot="{ errors }">
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.type"
                    :items="[
                      { id: 'buzones', name: 'Buzones' },
                      { id: 'marcador', name: 'Marcador' },
                      { id: 'manual', name: 'Manual' },
                      { id: 'entrante', name: 'Entrante' },
                      { id: 'todos', name: 'Todos' },
                    ]"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Tipo"
                    filled
                    rounded
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <!-- Largo origen -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="tarificador" rules="" v-slot="{ errors }">
                  <v-text-field
                    :disabled="isLoading || isEditMode"
                    v-model="payload.long_src"
                    :error-messages="errors"
                    label="Largo origen"
                    filled
                    rounded
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Largo destino -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="tarificador" rules="" v-slot="{ errors }">
                  <v-text-field
                    :disabled="isLoading || isEditMode"
                    v-model="payload.long_dst"
                    :error-messages="errors"
                    label="Largo destino"
                    filled
                    rounded
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Contexto -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="" rules="" v-slot="{ errors }">
                  <v-text-field v-model="payload.context" :error-messages="errors" label="Contexto" filled rounded>
                  </v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Troncal -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="" rules="" v-slot="{ errors }">
                  <v-text-field v-model="payload.troncal" :error-messages="errors" label="Troncal" filled rounded>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            Consultar
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },

  data() {
    return {
      isLoading: false,
      dateRangeMenu: false,
      pricingList: [],
      payload: {
        dateStart: "",
        dateEnd: "",
        type: undefined,
        long_src: undefined,
        long_dst: undefined,
        context: undefined,
        troncal: undefined,
      },
      dates: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
    };
  },

  computed: {
    selectedType() {
      return this.payload.type;
    },
  },

  watch: {
    selectedType(val) {
      if (val === "buzones") {
        this.payload.long_src = 11;
        this.payload.long_dst = 11;
        this.payload.troncal = "SIP/";
        this.payload.context = "from-pbxberry-predictive";
      }
      if (val === "marcador") {
        this.payload.long_src = 11;
        this.payload.long_dst = 4;
        this.payload.troncal = undefined;
        this.payload.context = "from-pbxberry-predictive";
      }
      if (val === "manual") {
        this.payload.long_src = 4;
        this.payload.long_dst = 11;
        this.payload.troncal = "SIP/out";
        this.payload.context = "from-internal";
      }
      if (val === "entrante") {
        this.payload.long_src = 11;
        this.payload.long_dst = 4;
        this.payload.troncal = "SIP/didw";
        this.payload.context = "from-pbxberry-predictive";
      }
      if (val === "todos") {
        this.payload.long_src = undefined;
        this.payload.troncal = undefined;
        this.payload.context = undefined;
        this.payload.long_dst = undefined;
      }
    },
  },

  methods: {
    resetform() {
      this.payload.dateStart = "";
      this.payload.dateEnd = "";
      this.dates = [];
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async submitForm() {
      const dateStart = this.dates[0];
      const dateEnd = this.dates[1];
      const clearedPayload = { dateStart, dateEnd };

      if (this.payload.type !== "todos") {
        clearedPayload.type = this.payload.type;
        clearedPayload.long_src = this.payload.long_src;
        clearedPayload.long_dst = this.payload.long_dst;
        clearedPayload.context = this.payload.context;
        clearedPayload.troncal = this.payload.troncal;
      }

      this.$emit("dialog:submit", clearedPayload);
    },
  },
};
</script>
